var moduleMap = {
	"./ViolationDrawer": () => {
		return Promise.all([__webpack_require__.e(7320), __webpack_require__.e(1993), __webpack_require__.e(1527), __webpack_require__.e(1928), __webpack_require__.e(8212), __webpack_require__.e(4609), __webpack_require__.e(6892), __webpack_require__.e(8211), __webpack_require__.e(8079), __webpack_require__.e(3452), __webpack_require__.e(9424), __webpack_require__.e(2654)]).then(() => (() => ((__webpack_require__(89611)))));
	},
	"./ViolationIcon": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(1928), __webpack_require__.e(4609), __webpack_require__.e(6892), __webpack_require__.e(8211), __webpack_require__.e(8079), __webpack_require__.e(2370)]).then(() => (() => ((__webpack_require__(40745)))));
	},
	"./PulsarLegend": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(4609), __webpack_require__.e(6892), __webpack_require__.e(5787)]).then(() => (() => ((__webpack_require__(25787)))));
	},
	"./AuditDrawer": () => {
		return Promise.all([__webpack_require__.e(7320), __webpack_require__.e(2834), __webpack_require__.e(1527), __webpack_require__.e(1928), __webpack_require__.e(8212), __webpack_require__.e(4609), __webpack_require__.e(6892), __webpack_require__.e(8211), __webpack_require__.e(8079), __webpack_require__.e(3452), __webpack_require__.e(8230), __webpack_require__.e(8464)]).then(() => (() => ((__webpack_require__(49058)))));
	},
	"./AuditLogs": () => {
		return Promise.all([__webpack_require__.e(7038), __webpack_require__.e(7320), __webpack_require__.e(1), __webpack_require__.e(8500), __webpack_require__.e(9920), __webpack_require__.e(2834), __webpack_require__.e(1420), __webpack_require__.e(1527), __webpack_require__.e(5929), __webpack_require__.e(1928), __webpack_require__.e(8212), __webpack_require__.e(4609), __webpack_require__.e(6892), __webpack_require__.e(8211), __webpack_require__.e(8079), __webpack_require__.e(3452), __webpack_require__.e(8230), __webpack_require__.e(3625)]).then(() => (() => ((__webpack_require__(36548)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});